import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const SalesSupervisorOrderSummary = () => {
  const { id } = useParams(); // Retrieve the ID from the route params
  const [order, setOrder] = useState(null); // State to store order details
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [error, setError] = useState(null); // State for error handling

  // State for managing updates to order and payment statuses
  const [updatedDeliverystatus, setUpdatedDeliverystatus] = useState('');
  const [updatedPaymentstatus, setUpdatedPaymentstatus] = useState('');
  const [showDeliveryStatusDropdown, setShowDeliveryStatusDropdown] = useState(false); // State to toggle delivery status dropdown
  const [showPaymentStatusDropdown, setShowPaymentStatusDropdown] = useState(false); // State to toggle payment status dropdown

  useEffect(() => {
    // Fetch order details by ID
    const fetchOrder = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const email = user.email;

        const response = await axios.get(`https://citi-mobile-app.onrender.com/admin/fulldetails/${id}/${email}`, {
          params: { email }, // Send the email as a query parameter
        });
        setOrder(response.data.order);
        setUpdatedDeliverystatus(response.data.order.deliverystatus);
        setUpdatedPaymentstatus(response.data.order.paymentstatus);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch order details');
        setLoading(false);
      }
    };

    fetchOrder();
  }, [id]);

  // Display loading spinner if the data is still being fetched
  if (loading) {
    return <div>Loading...</div>;
  }

  // Display error message if there is an issue fetching the data
  if (error) {
    return <div>{error}</div>;
  }

  // Check if the order data exists
  if (!order) {
    return <div>No order found</div>;
  }

  return (
    <div className="flex max-sm:flex-col max-sm:mt-20 justify-between max-w-5xl max-sm:w-screen mx-auto p-6 max-sm:p-0 bg-gray-50 max-sm:bg-white ml-60 max-sm:ml-0">
      {/* Products Section */}
      <div className="w-[45%] max-sm:w-full bg-white p-6 rounded-md shadow-md h-fit">
        <h2 className="text-xl font-bold mb-4">Products</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {order.products.map((product, index) => (
            <div key={index} className="flex items-center">
              <img
                src={product.image}
                alt={product.title}
                className="h-20 w-20 object-cover mr-4"
              />
              <div>
                <p className="font-semibold">{product.title}</p>
                <p className="font-semibold">{product.price}</p>
                <p className="text-blue-600">{product.cartonOption}</p>
                <p className="text-blue-600">{product.quantity}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Order Summary Section */}
      <div className="w-[45%] max-sm:w-full bg-white p-6 h-fit rounded-md shadow-md">
        <div className="mb-6">
          <p className="text-gray-600">Customer's Name:</p>
          <p className="font-semibold">{order.fullname}</p>
        </div>

        <div className="mb-6">
          <p className="text-gray-600">Delivery Details</p>
          <p>Delivery Address: {order.address}</p>
          <p>Delivery to: {order.deliveryTo}</p>
          <p>Phone Number: {order.phoneNumber}</p>
        </div>
        <div className="mb-6">
          <p className="text-gray-600">Total Amount:</p>
          <p className="font-semibold">{order.totalAmount}</p>
        </div>

        {/* Order Status Section with Select Option */}
        <div className="mb-6">
          <p className="text-gray-600">Order Status</p>
          <p>{order.deliverystatus}</p>
        </div>

        {/* Payment Status Section with Select Option */}
        <div className="mb-6">
          <p className="text-gray-600">Payment Status</p>
          <p>{order.paymentstatus}</p>
        </div>

        {/* Date Ordered Section */}
        <div className="mb-6">
          <p className="text-gray-600">Date Ordered</p>
          <span>{order.date}</span>
        </div>
      </div>
    </div>
  );
};

export default SalesSupervisorOrderSummary;
